<template>
  <!-- <NuxtLoadingIndicator color="#e50113" /> -->
  <NuxtPage />
  <Login ref="loginModal" />
  <!-- <CompleteInfo ref="completeInfoRef" /> -->
  <!-- <Toast ref="toastRef" /> -->
  <!-- 全局客服弹框 - 使用 v-if 实现真正的懒加载，打开时才加载组件 -->

  <!-- <CustomerServicePopup
    v-if="customerServiceVisible"
    v-model="customerServiceVisible" /> -->

  <NuxtErrorBoundary @error="logSomeError">
    <CustomerServicePopup
      v-if="customerServiceVisible"
      v-model="customerServiceVisible" />
    <!-- 出错时的 fallback UI -->
    <template #error="{ error, clearError }">
      <div class="error-customer-service">
        <p>客服出现错误：{{ error.message }}</p>
        <button @click="clearError">重试</button>
      </div>
    </template>
  </NuxtErrorBoundary>
</template>

<script lang="ts" setup>
  import { provide, nextTick } from 'vue'
  import { useCustomerServiceStore } from '~/stores/customerService'
  import { jufairLog } from '~/utils/common'

  const Login = defineAsyncComponent(() => import('~/components/Login/index.vue'))
  const CompleteInfo = defineAsyncComponent(() => import('~/components/CompleteInfo/index.vue'))
  const Toast = defineAsyncComponent(() => import('~/components/Toast/index.vue'))
  const CustomerServicePopup = defineAsyncComponent(
    () => import('~/components/CustomerService/CustomerServicePopup.vue')
  )

  const { locale } = useI18n()

  // 🔧 主动调用 useLang() 来根据域名设置正确的语言
  const { lang } = useLang()

  // 等待插件执行完成后再获取 locale 值
  await nextTick()
  // console.log('17--', locale.value, 'lang:', lang)
  const runtimeConfig = useRuntimeConfig()

  const route = useRoute()

  const token = useCookie('access_token')
  const globalStore = useGlobalStore()
  const customerServiceStore = useCustomerServiceStore()

  const logSomeError = (error: any) => {
    jufairLog(`216--error,${error}`)
  }

  // 客服弹框可见性 - 双向绑定到 store
  const customerServiceVisible = computed({
    get: () => customerServiceStore.isPopupVisible,
    set: val => {
      if (val) {
        customerServiceStore.openPopup()
      } else {
        customerServiceStore.closePopup()
      }
    }
  })

  // 提供全局打开客服弹框的方法
  const openCustomerService = (selectServiveId?: string | number) => {
    customerServiceStore.openPopup(selectServiveId)
  }
  provide('openCustomerService', openCustomerService)

  const loginModal = ref<typeof Login | null>(null) // 获取弹窗组件的模板引用
  provide<typeof loginModal>('loginModal', loginModal) // 提供给所有的子页面、子组件
  globalStore.setLoginModal(loginModal)

  // const toastRef = ref<typeof Toast | null>(null) // 获取弹窗组件的模板引用
  // provide<typeof toastRef>('Toast', toastRef) // 提供给所有的子页面、子组件

  // const completeInfoRef = ref<typeof CompleteInfo | null>(null) // 获取弹窗组件的模板引用
  // provide<typeof completeInfoRef>('CompleteInfo', completeInfoRef) // 提供给所有的子页面、子组件

  const getTraceScript = () => {
    if (runtimeConfig.public.MODE === 'dev') {
      return `trace.init({terminal: 'PC', channel: 'PC', apiUrl: 'http://localhost:7001' });`
    } else if (runtimeConfig.public.MODE === 'test') {
      return `trace.init({terminal: 'PC', channel: 'PC', apiUrl: 'https://vue.jufair.com' });`
    } else if (runtimeConfig.public.MODE === 'pre') {
      return `trace.init({terminal: 'PC', channel: 'PC', apiUrl: 'https://pre-pc.jufair.com' });`
    } else if (runtimeConfig.public.MODE === 'prod') {
      return `trace.init({terminal: 'PC', channel: 'PC' });`
    }
  }

  useHead({
    htmlAttrs: {
      lang: locale.value === 'zh' || locale.value === 'cn' ? 'zh-CN' : 'en-US'
    },
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, maximum-scale=5' // 'width=device-width, user-scalable=no' //
      },
      {
        name: 'baidu-site-verification',
        content: 'codeva-8wVWqXCP47'
      },
      {
        name: 'sogou_site_verification',
        content: 'ZKQmA3fOcE'
      },
      {
        name: 'applicable-device',
        content: 'pc'
      },
      {
        'http-equiv': 'X-UA-Compatible',
        content: 'ie=edge,chrome=1'
      },
      {
        'http-equiv': 'Cache-Control',
        content: 'no-transform'
      }
    ],
    script: [
      {
        innerHTML: `(function (n, e, r, t, a, o, s, i, c, l, f, m, p, u) {
        o = 'precollect';
        s = 'getAttribute';
        i = 'addEventListener';
        c = 'PerformanceObserver';
        l = function (e) {
          f = [].slice.call(arguments);
          f.push(Date.now(), location.href);
          (e == o ? l.p.a : l.q).push(f);
        };
        l.q = [];
        l.p = { a: [] };
        n[a] = l;
        m = document.createElement('script');
        m.src = r + '?aid=' + t + '&globalName=' + a;
        m.crossorigin = 'anonymous';
        m.async = true;
        m.defer = true;
        e.getElementsByTagName('head')[0].appendChild(m);
        if (i in n) {
          l.pcErr = function (e) {
            e = e || n.event;
            p = e.target || e.srcElement;
            if (p instanceof Element || p instanceof HTMLElement) {
              n[a](o, 'st', {
                tagName: p.tagName,
                url: p[s]('href') || p[s]('src'),
              });
            } else {
              n[a](o, 'err', e.error || e.message);
            }
          };
          l.pcRej = function (e) {
            e = e || n.event;
            n[a](o, 'reject', e.reason || (e.detail && e.detail.reason));
          };
          n[i]('error', l.pcErr, true);
          n[i]('unhandledrejection', l.pcRej, true);
        }
        if ('PerformanceLongTaskTiming' in n) {
          u = l.pp = { entries: [] };
          u.observer = new PerformanceObserver(function (e) {
            u.entries = u.entries.concat(e.getEntries());
          });
          u.observer.observe({ entryTypes: ['longtask'] });
        }
      });`
      },
      // {
      //   innerHTML: `window.apmPlus('init', {
      //   aid: 610525,
      //   token: '85b3ef401b0e4e86912e26260051b9fe',
      //   env: 'pro', // 区分不同环境
      // });
      // window.apmPlus('start');`
      // },
      {
        id: 'baidu',
        tagPosition: 'bodyClose', // 百度统计代码放到body底部
        innerHTML: `(function () {
        var bp = document.createElement('script');
        var curProtocol = window.location.protocol.split(':')[0];
        if (curProtocol === 'https') {
          bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
        } else {
          bp.src = 'http://push.zhanzhang.baidu.com/push.js';
        }
        bp.async = true;
        bp.defer = true;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(bp, s);
      })();`
      },
      {
        id: 'byte',
        tagPosition: 'bodyClose',
        innerHTML: `(function () {
        var el = document.createElement('script');
        el.src =
          'https://sf1-scmcdn-tos.pstatp.com/goofy/ttzz/push.js?17750af14d389d702b39c92e25b3287eebe353dcf893b79be2b75d85892447647676b9200b24343ce2b77f3ba04d89f8b7d9c860b5b19ba0b61a84e0f306ff36';
        el.id = 'ttzz';
        el.async = true;
        el.defer = true;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(el, s);
      })(window);`
      },
      {
        id: 'language',
        tagPosition: 'bodyClose',
        innerHTML: `if (window.location.host == 'www.jufair.com') {
        var _hmt = _hmt || [];
        (function () {
          var hm = document.createElement('script');
          hm.async = true;
          hm.defer = true;
          hm.src =
            'https://hm.baidu.com/hm.js?19bc6fcef522cf8e49c132c116c1d1f5';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(hm, s);
        })();
      }
      if (window.location.host == 'en.jufair.com') {
        var _hmt = _hmt || [];
        (function () {
          var hm = document.createElement('script');
          hm.async = true;
          hm.defer = true;
          hm.src =
            'https://hm.baidu.com/hm.js?03fc85a277c289bb7cec6fb751496428';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(hm, s);
        })();
      }`
      },
      {
        type: 'text/javascript',
        src: 'https://w3-file.jufair.com/prod/v4/js/trace.js'
      },
      {
        id: 'trace',
        innerHTML: getTraceScript()
      }
    ]
  })

  onMounted(() => {
    if (token.value && process.client) {
      globalStore.setIsLogin(true)
      globalStore.getUser()
    }
    // seo页面不显示客服
    if (process.client && !route.path.includes('/seo')) {
      // const script = document.createElement('script')
      // script.src = '//qfck70.kuaishang.cn/bs/ks.j?cI=376684&fI=3934'
      // script.type = 'text/javascript'
      // script.async = true
      // script.defer = true
      // document.body.appendChild(script)
    }
    // 谷歌流量分析
    // if (process.client) {
    //   const script1 = document.createElement('script')
    //   script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-01JX21BEFP'
    //   script1.async = true
    //   document.body.appendChild(script1)
    //   var Script2 = document.createElement('script')
    //   // 设置 script 内容（内联脚本）
    //   Script2.textContent = `
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag(){dataLayer.push(arguments);}
    //     gtag('js', new Date());
    //     gtag('config', 'G-01JX21BEFP');
    //   `
    //   document.body.appendChild(Script2)
    // }
  })
</script>

<style lang="less">
  html {
    font:
      16px/1.14 SF Pro Display,
      PingFang SC,
      Hiragino Sans GB,
      Microsoft YaHei,
      WenQuanYi Micro Hei,
      Helvetica Neue,
      Arial,
      sans-serif;
    color: #222;
    word-spacing: 1px;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a {
    text-decoration: none;
    color: #333;
  }

  .layout-container {
    min-width: 1190px;
    min-height: 100vh;
    background: #f7f7f7;
    display: flex;
    flex-direction: column;

    .slider-area {
      position: fixed;
      right: 0;
      bottom: 30%;
      width: 50px;
      background: #fff;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      //padding: 16px 0;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);

      ul {
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 14px;
          margin-bottom: 28px;
          cursor: pointer;
          position: relative;
          background: #fff;
          z-index: 8;

          &.tel {
            &:hover .tel-no {
              left: 0;
              transform: translateX(-103%);
            }
          }

          .box {
            background: #fff;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 8;
            padding-top: 16px;
            border-radius: 4px 0 0 0;
          }

          .tel-no {
            position: absolute;
            background-color: #fff;
            left: 100%;
            top: 0;
            transform: translateX(0);
            white-space: nowrap;
            font-family: 'Helvetica Neue', sans-serif;
            font-size: 14px;
            font-weight: bold;
            padding: 8px 8px 8px 16px;
            border-radius: 4px;
            // box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
            z-index: 7;
            // transition: all 0.3s linear;
            img {
              width: 120px;
              height: 120px;
            }
          }

          a {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 14px;
            cursor: pointer;
          }

          &:last-child {
            margin-bottom: 0;
            padding-bottom: 16px;
          }

          &:hover {
            span {
              color: @app-color;
            }
          }

          span {
            margin: 4px 0 0 0;
          }

          img {
            width: 23px;
            height: auto;
          }
        }
      }
    }
  }

  img {
    vertical-align: top;

    // &[data-src] {
    //   opacity: 0;
    //   transition: all 0.3s;
    // }
  }

  .browser {
    width: @client-width;
    margin: 0 auto;
    text-align: center;
    padding: 8px 0;
    color: #1890ff;
  }
  .el-message {
    z-index: 3000 !important;
  }
  .error-customer-service {
    position: fixed;
    top: 105px;
    right: 0px;
    z-index: 999;
    background: #fff;
    border-radius: 4px;
    padding: 8px 14px;
    cursor: grab;
    // display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 240px;
    box-shadow: -4px 2px 16px rgba(0, 0, 0, 0.2);
    user-select: none;
  }
</style>
